import styled from 'styled-components'

export const ShapeContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const ShapeWrapper = styled.div`
  transition: 0.2s;
`
